import { PageHeaderSection } from "../../models/page-builder/page-header-section.model";
import { TestimonialPageSection } from "../../models/page-builder/testimonial-page-section.model";
import { UploadedMedia } from "../../models/page-builder/uploaded-media.model";

export const MOCK_PAGE_TESTIMONIAL_SECTION: TestimonialPageSection = {
  type: "testimonial",
  content: {
    header: {
      title: "See What People Are Saying",
      titleColor: "#000000",
      subtitle:
        "Here are a few testimonials, check out for more.",
      subTitleColor: "#000000",
    },
    testimonials: {
      items: [
        {
          heading: "Amazing website for online course",
          headingColor: "#000000",
          description: "I have had my course on teachable for a few years and they recently removed their free plan. I only make a sale every month or two so paying would cost me money but wanted my course to be available because it sells well in other places and helps change people's lives, which is why I created it.",
          descriptionColor: "#000000",
          username: "Caitlyn Rosewood",
          usernameColor: "#000000",
          jobTitle: "",
          jobTitleColor: "#000000",
          reviewLink: "",
          creatorsWebsiteLink: "",
          addVerifiedUserBadge: false,
          avatarImage: {
            type: "image",
            originalFileName: "background-original",
            uploadFileName: "background.Mp4",
            url: '',//"https://play-lh.googleusercontent.com/7Ak4Ye7wNUtheIvSKnVgGL_OIZWjGPZNV6TP_3XLxHC-sDHLSE45aDg41dFNmL5COA=w240-h480-rw",
            imageSettings: {
              overlayWithBackground: true,
              opacity: 0.1,
              blending: "normal",
              blur: 2,
              grayScale: 10,
              contrast: 100,
            },
          },
          avatarBackgroundColor: "purple",
          avatarTextColor: "#ffffff",
        },
        {
          heading: "Best online course platform so far",
          headingColor: "#000000",
          description: "I have had my course on teachable for a few years and they recently removed their free plan. I only make a sale every month or two so paying would cost me money but wanted my course to be available because it sells well in other places and helps change people's lives, which is why I created it.",
          descriptionColor: "#000000",
          username: "Jane Doe",
          usernameColor: "#000000",
          jobTitle: "",
          jobTitleColor: "#000000",
          reviewLink: "",
          creatorsWebsiteLink: "",
          addVerifiedUserBadge: false,
          avatarImage: {
            type: "image",
            originalFileName: "ai",
            uploadFileName: "ai.webp",
            url: "https://www.aidemos.info/wp-content/uploads/2023/05/A_boy_simple_avatar_pixar_3d_rendering_Light_backgroun_3f9635f5-175c-4740-98c5-c53cd64885f8.webp",
            imageSettings: {
              overlayWithBackground: true,
              opacity: 0.1,
              blending: "normal",
              blur: 2,
              grayScale: 10,
              contrast: 100,
            },
          },
          avatarBackgroundColor: "#6F8FAF",
          avatarTextColor: "#ffffff",
        },
        {
          heading: "Way better than you might think",
          headingColor: "#000000",
          description: "I have had my course on teachable for a few years and they recently removed their free plan. I only make a sale every month or two so paying would cost me money but wanted my course to be available because it sells well in other places and helps change people's lives, which is why I created it.",
          descriptionColor: "#000000",
          username: "John Doe",
          usernameColor: "#000000",
          jobTitle: "",
          jobTitleColor: "#000000",
          reviewLink: "https://blog.ag-grid.com/how-to-write-a-podcast-app-using-react/",
          creatorsWebsiteLink: "https://blog.ag-grid.com/how-to-write-a-podcast-app-using-react/",
          addVerifiedUserBadge: true,
          avatarImage: {
            type: "image",
            originalFileName: "b",
            uploadFileName: "b",
            url: "https://promptstock.photos/wp-content/uploads/2023/11/3D-Cartoon-Avatars-6.png",
            imageSettings: {
              overlayWithBackground: true,
              opacity: 0.1,
              blending: "normal",
              blur: 2,
              grayScale: 10,
              contrast: 100,
            },
          },
          avatarBackgroundColor: "#6F8FAF",
          avatarTextColor: "#ffffff",
        },
      ]
    },
    verifiedUserBadge: {
      type: "image",
      originalFileName: "b3d",
      uploadFileName: "3d",
      url: "https://firebasestorage.googleapis.com/v0/b/chidume-local-dev.appspot.com/o/QqPcvz32KBXeg10On5kZNSwy0WD2%2FpageBuilder%2F1%2FVector.png?alt=media&token=4d2e4523-c709-4c00-9059-1ba1c8ca4314",
      imageSettings: {
        overlayWithBackground: true,
        opacity: 0.1,
        blending: "normal",
        blur: 2,
        grayScale: 10,
        contrast: 100,
      },
    },
    showStars: true
  },
  design: {
    layout: {
      blockStyle: 'card',
      imageAlignment: 'left'
    },
    appearance: {
      testimonialBackgroundColor: "#6F8FAF",
      sectionCardBackgroundColor: "#6F8FAF",
      sectionBackgroundColor: "#999999"
    }
  },
};
